"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var HelpSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M7,7.5 C7,7.57074667 7,7.73741334 7,8 L6.00574179,8 L6,7.5 C6,5.89052429 6.89052429,5 8.5,5 C10.1094757,5 11,5.89052429 11,7.5 L11,7.88196601 C11,8.75655713 10.5351562,9.5322876 9.7236068,9.9472136 C9.2763932,10.1339111 9,10.57652 9,11 L8,11 C8,10.1977479 8.43734741,9.44892883 9.2763932,9.0527864 C9.72346479,8.8417085 10,8.37778507 10,7.88196601 L10,7.5 C10,6.44280904 9.55719096,6 8.5,6 C7.44280904,6 7,6.44280904 7,7.5 Z M8,12 L9,12 L9,13 L8,13 L8,12 Z" })));
};
HelpSmall.displayName = 'HelpSmall';
exports.default = HelpSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=HelpSmall.js.map